module.exports = __webpack_public_path__ + "static/gm-42-90a23830856ddc31eaee1614c8a3b077.jpg";